import get from 'lodash/get'
import type { EfficiencyFactor, EfficiencyFactorMonth } from '../../station/stationTypes'

export const efficiencyFactorMonths: Array<EfficiencyFactorMonth> = Array.from(Array(12).keys()).map(
  (number) => (number + 1) as EfficiencyFactorMonth,
)

export const getEfficiencyFactorForMonth = (month: EfficiencyFactorMonth, data: Array<EfficiencyFactor>): number =>
  get(data.filter((ef) => ef.month === month)[0], 'efficiencyFactor')
